import AntdForm from 'antd/es/form';
import { FormProps, FormInstance } from 'antd/es/form';
import { forwardRef, Ref, ReactNode } from 'react';

function From<Values = any>(props: FormProps<Values> & { children?: ReactNode }, ref: Ref<FormInstance<Values>> | undefined) {
    return (
        <AntdForm {...props} ref={ref}>
            {props.children}
        </AntdForm>
    );
}

export default forwardRef(From);
